// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewerMenu__wrapper--1tHK9","center":"ViewerMenu__center--1chw-","end":"ViewerMenu__end--2dd2o","start":"ViewerMenu__start--3MVD0"};